'use client';
// components/layout/TrackingProvider.tsx
import { useTracking } from '@/lib/hooks/useTracking';
import { useEventTracking } from '@/lib/hooks/useEventTracking';

/**
 * Mounts the full page-tracking cycle plus site-wide interaction-event capture.
 * Invisible — renders nothing, only runs the hooks.
 */
export function TrackingProvider() {
    useTracking();        // page views + scroll/time metrics
    useEventTracking();   // clicks: downloads, contact, social, outbound
    return null;
}
